/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/datatypes';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "team_api": {
        "nested": {
          "CreateTeamMemberRequest": {
            "fields": {
              "idempotencyKey": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "teamMember": {
                "type": ".squareup.team_api.TeamMember",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "CreateTeamMemberResponse": {
            "fields": {
              "teamMember": {
                "type": ".squareup.team_api.TeamMember",
                "id": 1,
                "rule": "optional"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.team_api?.nested?.CreateTeamMemberRequest && !$root.nested?.squareup?.nested?.team_api?.nested?.CreateTeamMemberResponse) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents a create request for a `TeamMember` object.
 * --
 *
 * SOURCE CreateTeamMemberRequest @ squareup/team_api/endpoints/create-team-member.proto at 22:1
 */
export const CreateTeamMemberRequest = $root.lookupType('squareup.team_api.CreateTeamMemberRequest');
fixType(CreateTeamMemberRequest);
Builder.createAndAttachToType(CreateTeamMemberRequest);
/**
 * --
 * @desc Represents a response from a create request containing the created `TeamMember` object or error messages.
 * --
 *
 * SOURCE CreateTeamMemberResponse @ squareup/team_api/endpoints/create-team-member.proto at 43:1
 */
export const CreateTeamMemberResponse = $root.lookupType('squareup.team_api.CreateTeamMemberResponse');
fixType(CreateTeamMemberResponse);
Builder.createAndAttachToType(CreateTeamMemberResponse);